module.exports = __webpack_public_path__ + "img/03.9fc6b1da.png";